import type { Action } from 'redux';

import type { FeedConfig } from '../../state/feedConfig/types';
import type { FeedType } from '../../state/types';

export interface PartialFeedConfig {
  readonly threadCounts?: Partial<FeedConfig['threadCounts']>;
  readonly loadOlderThreadCounts?: Partial<FeedConfig['loadOlderThreadCounts']>;
}

export interface FeedConfigSetAction extends Action {
  readonly type: 'FEED_CONFIG.SET';
  readonly payload: {
    readonly feedConfig: PartialFeedConfig;
  };
}

export const threadCountExperimentFeedTypes: FeedType[] = ['Home', 'Group', 'User', 'UserWall'];
